import React from 'react';
import classNames from 'classnames';
import settings from '@/settings';
import { interpolateStoreTokens } from '@/lib/store-tokens';
import { useProductPageContext } from '../../hooks/useProductPageContext';
import ProductDescription from '@/components/v2/product/sections/secondary/ProductDescription';
import KeyFeatures from '../main/right/product/about/KeyFeatures';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const warningCategories = [
  'E-scooters',
  'E-skateboards',
  'Electric Bikes',
  'Hoverboards',
  'Hoverboard Bundle',
];

const isAUStore = ['reebelo-au'].includes(settings.store);

const MoreProductInfo = () => {
  const {
    product,
    selectedSkuDetails: { categoryName },
  } = useProductPageContext();

  // Catalogue descriptions are authored with {{country}} / {{return}} /
  // {{warranty}} placeholders shared across storefronts.
  const description = interpolateStoreTokens(product.description ?? '');

  const shouldShowDisclaimer =
    isAUStore && !!categoryName && warningCategories.includes(categoryName);

  if (!description && !shouldShowDisclaimer) {
    return null;
  }

  // Get features
  const features = product.features ?? [];

  return (
    <div className="w-full border-t border-[#EDF4F4] bg-[linear-gradient(204deg,_#DBFEFF_19%,_#F3FEFE_41%,_#FFFFFF_79%)]">
      <div className="reebelo-container grid justify-between space-y-10 py-10 md:grid-cols-12 md:space-x-12 md:space-y-0 xl:space-x-20">
        <div
          className={classNames('', {
            'md:col-span-6 xl:col-span-8': features.length > 0,
            'col-span-12': features.length === 0,
          })}
        >
          {description && (
            <>
              <h2 className="mb-2 text-xl font-bold text-gray-700 xs:text-2xl">
                {t`Product Description`}
              </h2>
              <ProductDescription
                text={description}
                shouldShowDisclaimer={shouldShowDisclaimer}
                productName={product.name}
              />
            </>
          )}
        </div>

        <KeyFeatures />
      </div>
    </div>
  );
};

export default MoreProductInfo;
